const CHUNK_RELOAD_KEY = 'hr:chunk-reload-once';

let reloadStarted = false;

export const clearChunkReloadFlags = () => {
  if (typeof window === 'undefined') return;
  try {
    sessionStorage.removeItem(CHUNK_RELOAD_KEY);
  } catch {
    // ignore
  }
};

const chunkUrlFromError = (error) => {
  const request = error?.request;
  if (typeof request === 'string' && request.includes('/js/')) return request;
  const filename = error?.filename;
  if (typeof filename === 'string' && filename.includes('/js/')) return filename;
  const match = String(error?.message || '').match(/https?:\/\/[^\s)]+\.js/);
  return match ? match[0] : '';
};

const isSameOriginChunk = (url) => {
  try {
    const parsed = new URL(url, window.location.origin);
    return parsed.origin === window.location.origin
      && parsed.pathname.includes('/js/')
      && parsed.pathname.endsWith('.js');
  } catch {
    return false;
  }
};

// Hashed /js files are cached for years. A truncated response stays in the HTTP
// cache, so a plain reload parses the same cut-off file again.
const refreshChunkInHttpCache = (url) => {
  if (!isSameOriginChunk(url) || typeof fetch !== 'function') {
    return Promise.resolve();
  }
  return fetch(url, { cache: 'reload', credentials: 'same-origin' }).then(() => {}, () => {});
};

export const isChunkLoadError = (error) => {
  const message = String(error?.message || '').toLowerCase();
  const filename = String(error?.filename || error?.request || '');
  const truncatedChunk = message.includes('unexpected end of input')
    && /\/js\/[^/]+\.js(?:$|\?)/.test(filename);
  return error?.name === 'ChunkLoadError'
    || message.includes('loading chunk')
    || message.includes('failed to fetch dynamically imported module')
    || message.includes('importing a module script failed')
    || truncatedChunk;
};

export const recoverFromChunkLoadError = (error) => {
  if (!isChunkLoadError(error) || typeof window === 'undefined') {
    return false;
  }
  if (reloadStarted) return true;

  let hasRetried = false;
  try {
    hasRetried = window.sessionStorage.getItem(CHUNK_RELOAD_KEY) === '1';
  } catch {
    // ignore
  }
  if (hasRetried) return false;

  reloadStarted = true;
  try {
    window.sessionStorage.setItem(CHUNK_RELOAD_KEY, '1');
  } catch {
    // ignore
  }

  const reload = () => window.location.reload();
  const refresh = refreshChunkInHttpCache(chunkUrlFromError(error));
  const timeout = new Promise((resolve) => {
    window.setTimeout(resolve, 4000);
  });
  Promise.race([refresh, timeout]).then(reload, reload);
  return true;
};
